/* export as OenUiAlertThemes */
export const themes = [
  'red',
  'primary',
  'yellow',
  'green',
  'blue',
  'purple',
  'pink',
  'gray',
  'dark',
] as const
export type Themes = (typeof themes)[number]
